import React, { FC } from "react";
import { Table } from "antd";
import type { ColumnsType } from "antd/lib/table";
import "./HoverTable.scss";
import { columns as rawColumns, dataSource as rawData } from "./utils";

export interface RowType {
  key: string;
  center: string;
  status: string;
  stock: number | string;
  awaiting: number | string;
  sold: number;
}

const columns = rawColumns as unknown as ColumnsType<RowType>;
const dataSource = rawData as unknown as RowType[];

const renderSummary = (): React.ReactNode => (
  <Table.Summary>
    <Table.Summary.Row>
      <Table.Summary.Cell index={0} className="total-cell">
        TOTAL
      </Table.Summary.Cell>
      <Table.Summary.Cell index={1} className="total-cell" />
      <Table.Summary.Cell index={2} className="total-cell">
        140
      </Table.Summary.Cell>
      <Table.Summary.Cell index={3} className="total-cell">
        120
      </Table.Summary.Cell>
      <Table.Summary.Cell index={4} className="total-cell">
        50
      </Table.Summary.Cell>
    </Table.Summary.Row>
  </Table.Summary>
);

const HoverTable: FC = () => {
  return (
    <Table<RowType>
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      bordered={false}
      className="hover-table"
      summary={renderSummary}
    />
  );
};

export default HoverTable;
